import type { CalculatorQuoteDraft, QuoteExtraItem, QuoteOriginId } from "./types";

export function calculatorDraftToLine(
  draft: CalculatorQuoteDraft,
  includeInternalCost: boolean,
): QuoteExtraItem {
  const quantity = Math.max(1, Number(draft.units) || 1);
  const configuredTax = Number(draft.summary.ivaPorcentaje);
  const taxPercentage = Math.max(0, Number.isFinite(configuredTax) ? configuredTax : 16);
  const subtotal = draft.saleTotal / (1 + taxPercentage / 100);
  const details = Object.entries(draft.summary)
    .filter(([key, value]) => key !== "ivaPorcentaje" && value !== "" && value !== null
      && (draft.calculator !== "vinyl" || ["medida", "acabados", "complementos"].includes(key)))
    .slice(0, 4)
    .map(([key, value]) => `${key}: ${String(value)}`)
    .join(" · ")
    .slice(0, 240);

  return {
    id: globalThis.crypto?.randomUUID?.() || `calculation-${Date.now()}-${Math.random()}`,
    kind: "other",
    origin: draft.calculator,
    deliverable: true,
    label: draft.title,
    quantity,
    saleUnit: subtotal / quantity,
    costUnit: includeInternalCost ? draft.costTotal / quantity : undefined,
    supplier: "",
    notes: details,
  };
}

export function quoteLineOrigins(items: QuoteExtraItem[]): QuoteOriginId[] {
  return [...new Set(items.map((item) => item.origin || "direct"))];
}

export function mergeCalculatorLines(current: QuoteExtraItem[], incoming: QuoteExtraItem[]): QuoteExtraItem[] {
  const existingIds = new Set(current.map((item) => item.id));
  const additions = incoming.filter((item) => !existingIds.has(item.id));
  if (additions.length === 0) return current;
  return [...current.filter((item) => item.label.trim() || item.saleUnit > 0), ...additions];
}
